/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2, breakpoints } from '@coursera/cds-core';

import { useXDPRedesignPhase1Data } from 'bundles/unified-description-page-common/providers/specialization/XDPRedesignPhase1Provider';

const orginalStyles = {
  badge: css`
    display: inline-block;
    background-color: var(--cds-color-blue-100);
    padding: 1px 5px;
    border-radius: 4px;
  `,
  badgeText: css`
    font-weight: 600;
    white-space: nowrap;
  `,
};

const thickStyles = {
  badge: css`
    display: inline-block;
    background-color: var(--cds-color-blue-100);
    padding: var(--cds-spacing-50) var(--cds-spacing-150);
    border-radius: 4px;

    ${breakpoints.down('sm')} {
      padding: 1px var(--cds-spacing-100);
    }
  `,
  badgeText: css`
    font-weight: 600;
    white-space: nowrap;
  `,
};

type Props = {
  designStyle?: 'original' | 'thick';
};

function Badge({ children, designStyle = 'original' }: React.PropsWithChildren<Props>) {
  const { enableXDPRedesignPhase1, enableXDPRedesignHero } = useXDPRedesignPhase1Data();
  const enableXDPRedesign = enableXDPRedesignPhase1 || enableXDPRedesignHero;
  const styles = designStyle === 'thick' ? thickStyles : orginalStyles;

  return (
    <div css={styles.badge}>
      <Typography2
        variant={enableXDPRedesign ? 'subtitleSmall' : 'subtitleMedium'}
        component="div"
        color="highlightBlue"
        css={styles.badgeText}
      >
        {children}
      </Typography2>
    </div>
  );
}

export default Badge;
